export default function() {
    this.loadDay()
}
